export default "__VITE_ASSET__CL7o$Y8D__"